<template>
  <v-dialog
    :fullscreen="isMobileBreakpoint"
    v-model="openModal"
    persistent
    max-width="600"
  >
    <v-card class="py-3">
      <v-toolbar elevation="0" class="pl-3 pb-3">
        <v-toolbar-title>
          <span class="body-bold-medium neutral-20-dark--text">
            {{ $t('message.playlists.titleCreatePlaylist') }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn :disabled="loading" icon @click="cancelCreation">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="mt-3">
        <v-textarea
          :label="$t('message.title')"
          :placeholder="$t('message.typeTitle')"
          v-model="inputTitle"
          counter="40"
          class="mb-2"
          maxlength="40"
          rows="1"
          auto-grow="false"
        ></v-textarea>
        <v-textarea
          :label="$t('message.description')"
          :placeholder="$t('message.typeDescription')"
          v-model="inputDescription"
          counter="160"
          maxlength="160"
        ></v-textarea>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pt-6 pr-6">
        <v-spacer v-if="!isMobileBreakpoint"></v-spacer>
        <base-btn
          :disabled="loading"
          class="mr-3"
          type="tertiary"
          @click="cancelCreation"
        >
          {{ $t('message.actions.cancel') }}
        </base-btn>
        <base-btn
          type="primary"
          @click="savePlaylist"
          :disabled="inputTitle.length < 3 || loading"
          :loading="loading"
        >
          {{ $t('message.actions.publish') }}
        </base-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import playlistApi from '../services/playlistApi'
export default {
  name: 'CreatePlaylistModal',
  props: {
    openModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    selectedVideos: {
      type: Array,
    },
  },
  data: () => ({
    inputTitle: '',
    inputDescription: '',
    loading: false,
  }),
  computed: {
    ...mapState('user', {
      planInfo: 'userPlanInfo',
      mainVideos: 'mainVideos',
      subFolderVideos: 'subFolderVideos',
      deletedFolders: 'deletedFolders',
      isTabletBreakpoint: 'isTabletBreakpoint',
      isMobileBreakpoint: 'isMobileBreakpoint',
      userFirstAccess: 'userFirstAccess',
      isRecapAvailable: 'isRecapAvailable',
      isPandaBrandingActive: 'isPandaBrandingActive',

      isDrmActive: (state) => state.drmData.isDrmActive,
      drmGroupsLoading: (state) => state.drmData.loadings.drmGroups,
      drmGroups: (state) => state.drmData.drmGroups,
    }),
  },
  methods: {
    ...mapMutations('playlist', ['UPDATE_PLAYLIST', 'UPDATE_PLAYLIST_VIDEOS']),
    async savePlaylist() {
      this.loading = true
      const selectedVideosIds = this.selectedVideos.map((video, index) => {
        return {
          video_id: video.id,
          order: index,
        }
      })
      const newPlaylist = {
        name: this.inputTitle.trim(),
        description: this.inputDescription.trim(),
        access_type: 'anyone_with_link',
        creator_name: this.planInfo.user.name,
      }
      const response = await playlistApi.createPlaylist(newPlaylist)
      if (response.data) {
        const id = response.data.id
        const videos = await playlistApi.updatePlaylistVideos(
          selectedVideosIds,
          id
        )
        if (videos) this.UPDATE_PLAYLIST(videos)
        this.$router.push({ path: `/playlist/${id}` })
      }
      this.cancelCreation()
      this.loading = false
      this.inputTitle = ''
      this.inputDescription = ''
    },
    cancelCreation() {
      this.inputTitle = ''
      this.inputDescription = ''
      this.$emit('update:openModal', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.v-textarea textarea {
  resize: none;
}
</style>
